import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-populasi-khusus", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-populasi-khusus/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-populasi-khusus`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-populasi-khusus/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPerawat(id: number, data) {
  const response = await http
    .putData(`/asesmen-populasi-khusus/${id}/sign-perawat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http
    .putData(`/asesmen-populasi-khusus/${id}/sign-dpjp`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPpja(id: number, data) {
  const response = await http
    .putData(`/asesmen-populasi-khusus/${id}/sign-ppja`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-populasi-khusus/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(
    `${http.getAPI()}/asesmen-populasi-khusus/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  find,
  signPerawat,
  signDpjp,
  signPpja,
  destroy,
  print
};
